export const FORM_STATES = {
	DATA: 'DATA',
	CONFIRMATION: 'CONFIRMATION',
	LOADING: 'LOADING',
	SUCCESS: 'SUCCESS',
	ERROR: 'ERROR'
};
